<template>
  <div class="first-step__image">
    <div class="first-step__wrapper">
      <div class="first-step__container">
        <div class="first-step__content">
          <h2 class="first-step__title">
            Зроби свій перший крок.<br /><span class="first-step__title-thin"
              >Тебе шукають бренди та агенції</span
            >
          </h2>
          <a
            class="first-step__button"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeqH_MlJWDVN0OUicbCBT2CMPqYCCc5VqSzXFQw7Eds39FHWQ/viewform"
          >
            Записатися на проби
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "talent-first-step-block",
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.first-step {
  &__image {
    background-image: url("/static/img/banner-talent-step.svg");
    background-size: cover;
    background-position: center;
  }
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }

  &__container {
    display: flex;
    justify-content: center;
    padding: 145px 24px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 40px;
  }

  &__title {
    font-family: "Inter", sans-serif;

    font-size: 60px;
    line-height: 60px;
    font-weight: 500;
    letter-spacing: -0.02em;
    text-align: center;
    max-width: 538px;
    &-thin {
      font-family: "Nyght Serif";

      font-weight: 300;
    }
  }

  &__button {
    background-color: #fcc10f;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 222px;
    height: 40px;
    font-family: "Inter", sans-serif;

    font-size: 14px;
    color: #000000;
    border-radius: 8px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

@media (max-width: 650px) {
  .first-step {
    &__title {
      font-size: 36px;
      line-height: 36px;
      font-weight: 500;
    }

    &__image {
      background-image: url("/static/img/banner-talent-step-mobile.svg");
    }

    &__container {
      padding: 110px 24px;
    }

    &__content {
      row-gap: 32px;
    }
    &__button {
      width: 100%;
    }
  }
}
</style>
